import * as React from 'react';

import styles from './location-empty-view.module.css';

export function LocationEmptyView() {
    return (
        <div className={styles['location-empty-view']}>
            <h2 className={styles.title}>Nothing was found.</h2>
            <img src='/include/images/empty-states/location.png' className={styles.image} />
        </div>
    );
}
